import React, { FC } from 'react'
import { CiSearch } from "react-icons/ci";
import './FilterSearchText.scss'

interface IFilterSearchTextProps {
  value?: string
  onChange?: (event: any) => void

}

const FilterSearchText: FC<IFilterSearchTextProps> = ({value, onChange}) => {

  return (
    <div style={{position: 'relative', marginBottom: 10, width: '100%'}}>
      <input value={value} onChange={onChange} placeholder='Buscar por palabra clave' className='filter-course-characteristics--search' />
      <CiSearch style={{position: 'absolute', right: '12px', top: '12px', color: '#57575C'}}/>
    </div>
  )
}

export default FilterSearchText
